import { z } from 'zod';
import { FeedSyncJobSchema } from './listJob.js';
/** Data bindings are per job: a calendar sync binds encounter columns, outreach patient ones. */
export const FeedDataBindingsQuerySchema = z.object({ job: FeedSyncJobSchema }).strict();
//# sourceMappingURL=dataBindings.js.map